/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">제품을 배송하기 위하여, 저희는 고객님의 성명, 전화번호, 그리고 배송 주소를 수집하여 제3자인 협력업체와 공유합니다. </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">고객님과의 계약을 이행하기 위해 반드시 필요한 경우에만 개인정보를 처리하며, 이것이 개인정보 처리의 법적인 근거가 됩니다. </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">위 목적을 위하여, 저희는 고객님의 개인정보를 아래의 제3자에게 이전할 수 있습니다. </span>
                </p>
                <table border="1" cellpadding="5" cellspacing="0" style="border-collapse:collapse; width:100%; margin-top:12pt; margin-bottom:12pt; font-family:Arial; font-size:8pt;">
                    <thead>
                        <tr style="background-color:#f5f5f5;">
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:5%;">순번</th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:18%;">제공받는 자</th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:18%;">제공되는 개인정보 항목</th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:20%;">제공받는 자의 이용 목적</th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:24%;">제공받는 자의 보유 및 이용 기간 </th>
                            <th style="border:1px solid #000; padding:5px; text-align:center; font-weight:bold; width:15%;">개인정보 보호정책</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="border:1px solid #000; padding:5px; text-align:center; width:5%;">1</td>
                            <td style="border:1px solid #000; padding:5px; width:18%;">샤오미테크놀로지 코리아 유한책임회사 Xiaomi Technology Korea LLC.</td>
                            <td style="border:1px solid #000; padding:5px; width:18%;">성명, 전화번호, 및 배송주소</td>
                            <td style="border:1px solid #000; padding:5px; width:20%;">관련 제품의 배송 및 설치 제공 서비스</td>
                            <td style="border:1px solid #000; padding:5px; width:24%;">적용 법률에서 달리 기재되어 있는 경우를 제외하고, 수집 및 이용 목적이 달성될 때까지</td>
                            <td style="border:1px solid #000; padding:5px; width:15%; word-wrap:break-word; word-break:break-word;">샤오미의 개인정보 보호 정책은 
                                <a href="https://privacy.mi.com/all/languages" style="text-decoration:none; color:#3370ff; word-break:break-all;">https://privacy.mi.com/all/languages</a> 에서 확인할 수 있음. 
                            </td>
                        </tr>
                        <tr>
                            <td style="border:1px solid #000; padding:5px; text-align:center; width:5%;">2</td>
                            <td style="border:1px solid #000; padding:5px; width:18%;">(주)한진 HANJIN Logistics Corporation.</td>
                            <td style="border:1px solid #000; padding:5px; width:18%;">성명, 전화번호, 및 배송주소</td>
                            <td style="border:1px solid #000; padding:5px; width:20%;">관련 제품의 배송 및 설치 제공 서비스</td>
                            <td style="border:1px solid #000; padding:5px; width:24%;">적용 법률에서 달리 기재되어 있는 경우를 제외하고, 수집 및 이용 목적이 달성될 때까지</td>
                            <td style="border:1px solid #000; padding:5px; width:15%;"></td>
                        </tr>
                        <tr>
                            <td style="border:1px solid #000; padding:5px; text-align:center; width:5%;">3</td>
                            <td style="border:1px solid #000; padding:5px; width:18%;">SK네트웍스서비스(주)</td>
                            <td style="border:1px solid #000; padding:5px; width:18%;">성명, 전화번호, 주소, 전자우편주소, 주문번호, 주문수량, 제품명, 제품 IMEI/SN, 물류추적번호.</td>
                            <td style="border:1px solid #000; padding:5px; width:20%;">주문 지원, AS 지원, 제품 기술 지원 및 고객 불만 처리</td>
                            <td style="border:1px solid #000; padding:5px; width:24%;">적용 법률에서 달리 기재되어 있는 경우를 제외하고, 수집 및 이용 목적이 달성될 때까지</td>
                            <td style="border:1px solid #000; padding:5px; width:15%;"></td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">개인정보 처리 방식이나 고객님의 데이터 보호 권리(예: 열람, 정정, 및/또는 삭제) 행사 방법에 대하여 궁금한 점이 있으시면 매장 직원에게 문의하시기 바랍니다.</span>
                </p>
            </div>
        </body>
    </html>`;

    
function AuthPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(AuthPage)